/*
 * @Author: wp
 * @Date: 2023-01-03 15:47:54
 * @Descripttion:
 */
/*
 * @Author: wp
 * @Date: 2023-01-03 14:21:05
 * @Descripttion:
 */
/*
 * @Author: wp
 * @Date: 2022-12-28 18:44:08
 * @LastEditors: wp530511
 * @LastEditTime: 2025-06-04 16:03:25
 * @Desorption:
 */
// const isProd = process.env.VUE_APP_apiUrl === 'https://www.pzds.com/api/v2';
module.exports = {
    //   是否开启需要微信关注
    openWxFollow: false,
    //   是否开启需要用户点击咨询客服和立即购买需要登录盼之账户
    openServiceAuth: true, // 咨询客服按钮
    openBuyAuth: true, // 立即购买按钮
    //   是否使用第三方客服链接
    thirdPartyServiceUrl: true,
    //   是否开启砍价
    openHackBargain: true,
    recoverys: true,
    //   需要登录的页面(要加“/”)
    needLogin: [
        '/advise',
        '/selectGame',
        '/selectServer',
        '/editAccount',
        // 个人中心
        '/account',
        '/account/userinfo',
        '/account/buyerCenter',
        '/account/buyerList',
        '/account/buyerDetails',
        '/account/recovery',
        '/account/business',
        '/account/collection',
        '/account/sellerCenter',
        '/account/sellerOrder',
        '/account/sellerList',
        '/account/sellerDetails',
        '/account/addMoney',
        '/account/consultList',
        '/account/tiXianResultDetails',
        '/account/realName',
        '/account/authHome',
        '/account/faceRecognition',
        '/account/realNameDetail',
        '/account/tiXian',
        '/account/addTiXianAccount',
        '/account/tiXianAccount',
        '/account/tiXianHistory',
        '/account/mingXi',
        '/account/setPayPassword',
        '/account/message',
        '/account/messageDetails',
        '/account/serveList',
        '/account/serveDetails',
        '/account/coupon',
        '/account/equityExchange',
        '/account/similar',
        // 订单
        '/confirmOrder/contactInfo',
        '/confirmOrder/payment',
        '/center/questionnaire',
        // 中介担保
        '/Intermediary'
    ],
    // 需要随机数的页面(路由名字)
    needRandom: ['goodsList'],
    randomNumber: Math.floor(Math.random() * 150),
    IMG_OSS: 'https://oss.pzds.com/pc-ssr-im'
}
